export default __webpack_public_path__ + "static/media/virus-3.79a094b8.svg";